import React from 'react';
import History from './History';
import Layout from '../common/Layout';
import reportService from '../../services/reportService';

export default function () {
    return <Layout>
        <History reportService={reportService} />
    </Layout>
};